import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../i18n';
import PageHero from '../components/PageHero';
import HighlightPhrase from '../components/HighlightPhrase';
import { SectionWrap, SectionHeader, Bullets, TitledBullets, Prose } from '../components/SectionPrimitives';

import { VIDAT_IMG } from '../lib/images';

const IMG = VIDAT_IMG.estanque1;

const Cardiometabolica = () => {
  const { content } = useI18n();
  const c = content.cardio;
  const buttons = content.buttons;
  return (
    <main data-testid="cardio-page">
      <PageHero eyebrow={c.eyebrow} title={c.title} lead={c.lead} image={IMG} testId="cardio-hero" />

      <SectionWrap bg="ivory" testId="cardio-forwhom">
        <SectionHeader title={c.forWhomTitle} />
        <p className="text-stone-700 font-light max-w-2xl mb-8">{c.forWhomLead}</p>
        <Bullets items={c.forWhom} />
      </SectionWrap>

      <SectionWrap testId="cardio-problem">
        <SectionHeader title={c.problemTitle} />
        <Prose paragraphs={[c.problemP1, c.problemP2]} />
      </SectionWrap>

      <SectionWrap bg="ivory" testId="cardio-eval">
        <SectionHeader title={c.evalTitle} />
        <p className="text-stone-700 font-light mb-8 max-w-2xl">{c.evalLead}</p>
        <TitledBullets items={c.eval} />
      </SectionWrap>

      <SectionWrap testId="cardio-integration">
        <SectionHeader title={c.integrationTitle} />
        <Prose paragraphs={[c.integrationP1, c.integrationP2]} />
        <div className="mt-8"><Bullets items={c.integrationList} /></div>
      </SectionWrap>

      <SectionWrap bg="ivory" testId="cardio-interpretation">
        <SectionHeader title={c.interpretationTitle} />
        <Prose paragraphs={[c.interpretationP1, c.interpretationP2]} />
        <div className="mt-8"><Bullets items={c.interpretationList} /></div>
      </SectionWrap>

      <SectionWrap testId="cardio-obtain">
        <SectionHeader title={c.obtainTitle} />
        <Bullets items={c.obtain} />
        <div className="mt-12 flex flex-wrap gap-4">
          <Link to="/programar-visita" className="btn-primary" data-testid="cta-join-first">
            {buttons.joinFirstAssessments}
          </Link>
        </div>
      </SectionWrap>

      <HighlightPhrase eyebrow={c.modelEyebrow} dark testId="cardio-highlight">
        {c.modelHighlight}
      </HighlightPhrase>

    </main>
  );
};

export default Cardiometabolica;
